/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Player_Spell_DatesInputs */

const th_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} ถึง ${i?.to}`)
};

const en_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} to ${i?.to}`)
};

const ja_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from}〜${i?.to}`)
};

const zh_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} 至 ${i?.to}`)
};

const es_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`de ${i?.from} a ${i?.to}`)
};

const pt_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`de ${i?.from} a ${i?.to}`)
};

const id_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} sampai ${i?.to}`)
};

const fr_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`du ${i?.from} au ${i?.to}`)
};

const tl_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} hanggang ${i?.to}`)
};

const vi_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} đến ${i?.to}`)
};

const ko_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from}부터 ${i?.to}까지`)
};

const de_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} bis ${i?.to}`)
};

const ru_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} — ${i?.to}`)
};

const tr_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} – ${i?.to}`)
};

const it_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Da ${i?.from} a ${i?.to}`)
};

const pl_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Od ${i?.from} do ${i?.to}`)
};

const uk_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} — ${i?.to}`)
};

const hi_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} से ${i?.to} तक`)
};

const ar_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`من ${i?.from} إلى ${i?.to}`)
};

const ms_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} hingga ${i?.to}`)
};

const bn_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} থেকে ${i?.to}`)
};

const zh_tw2_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} 至 ${i?.to}`)
};

const zh_hk2_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} 至 ${i?.to}`)
};

const ur_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} سے ${i?.to} تک`)
};

const fa_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} تا ${i?.to}`)
};

const sw_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} hadi ${i?.to}`)
};

const nl_player_spell_dates = /** @type {(inputs: Player_Spell_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} tot ${i?.to}`)
};

/**
* | output |
* | --- |
* | "{from} to {to}" |
*
* @param {Player_Spell_DatesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_spell_dates = /** @type {((inputs: Player_Spell_DatesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Spell_DatesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_spell_dates(inputs)
	if (locale === "ja") return ja_player_spell_dates(inputs)
	if (locale === "zh") return zh_player_spell_dates(inputs)
	if (locale === "es") return es_player_spell_dates(inputs)
	if (locale === "pt") return pt_player_spell_dates(inputs)
	if (locale === "id") return id_player_spell_dates(inputs)
	if (locale === "fr") return fr_player_spell_dates(inputs)
	if (locale === "tl") return tl_player_spell_dates(inputs)
	if (locale === "vi") return vi_player_spell_dates(inputs)
	if (locale === "ko") return ko_player_spell_dates(inputs)
	if (locale === "de") return de_player_spell_dates(inputs)
	if (locale === "ru") return ru_player_spell_dates(inputs)
	if (locale === "tr") return tr_player_spell_dates(inputs)
	if (locale === "it") return it_player_spell_dates(inputs)
	if (locale === "pl") return pl_player_spell_dates(inputs)
	if (locale === "uk") return uk_player_spell_dates(inputs)
	if (locale === "hi") return hi_player_spell_dates(inputs)
	if (locale === "ar") return ar_player_spell_dates(inputs)
	if (locale === "ms") return ms_player_spell_dates(inputs)
	if (locale === "bn") return bn_player_spell_dates(inputs)
	if (locale === "zh-TW") return zh_tw2_player_spell_dates(inputs)
	if (locale === "zh-HK") return zh_hk2_player_spell_dates(inputs)
	if (locale === "ur") return ur_player_spell_dates(inputs)
	if (locale === "fa") return fa_player_spell_dates(inputs)
	if (locale === "sw") return sw_player_spell_dates(inputs)
	if (locale === "nl") return nl_player_spell_dates(inputs)
	return en_player_spell_dates(inputs)
});